export default {
  tags: ({ tags }) => tags,
};
